module.exports = "<div class=\"dd-list__list\">\r\n    <div class=\"js-list-region dd-list__wrp\"></div>\r\n    <div class=\"js-scrollbar-region dd-list__scrollbar\"></div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/common/members/templates/panel.hbs
// module id = 655
// module chunks = 0